var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalPeaks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M593 600L620 480L539 360L683 240L674 120L602 0L900 0L900 120L900 240L900 360L900 480L900 600Z",
    fill: "#2ebee4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449 600L449 480L431 360L521 240L494 120L440 0L603 0L675 120L684 240L540 360L621 480L594 600Z",
    fill: "#1a98c2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188 600L179 480L134 360L179 240L215 120L125 0L441 0L495 120L522 240L432 360L450 480L450 600Z",
    fill: "#0a74a0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 600L0 480L0 360L0 240L0 120L0 0L126 0L216 120L180 240L135 360L180 480L189 600Z",
    fill: "#00527c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalPeaks);
export default __webpack_public_path__ + "static/media/horizontal_peaks.9feb057c9c00e16c3527e2caf2be51a6.svg";
export { ForwardRef as ReactComponent };